import React from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { get } from 'services';

const AttachmentsCard = ({documento, dniTypes}) => {

    const download = async () => {
        //window.open('https://sxhumanostoragetest.blob.core.windows.net/arshumanoattachmentfiles/' + documento.enlaceUI + process.env.REACT_APP_SAS_TOKEN, '_blank');
        window.open(process.env.REACT_APP_API_URL + '/PersonaDocumento/DownloadFileByName/' + documento.enlaceUI, '_blank');
    }

    return (
        <>
            <Card>
                <Card.Body className={'p-20'}>
                    <strong> { dniTypes.length > 0 && 
                    dniTypes.find(x => x.id == documento.tipoDocumentoIdUI)?.nombre
                }: </strong> { documento.documentoNombreUI } &nbsp; <Button variant="primary" size="sm" onClick={download}><i className="fas fa-download"></i></Button>
                </Card.Body>
            </Card>
            <br/>
        </>
    );
};

export default AttachmentsCard;